import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TEST_URL } from '@/api/config/api.config';

export interface ICreateLeadPayload {
  full_name?: string;
  phone: string;
  email?: string;
  organization?: string;
  comment?: string;
}

export interface ICreateLeadResponse {
  id: number;
  bitrix_synced: boolean;
}

export interface ICreateCallbackPayload {
  full_name?: string;
  phone: string;
  comment?: string;
}

export const leadApi = createApi({
  reducerPath: 'leadApi',
  baseQuery: fetchBaseQuery({
    baseUrl: TEST_URL,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    createLead: builder.mutation<
      ICreateLeadResponse,
      { session: string; lead: ICreateLeadPayload }
    >({
      query: ({ session, lead }) => ({
        url: '/leads',
        method: 'POST',
        headers: { 'Guest-Uuid': session },
        body: { lead },
      }),
    }),
    createCallback: builder.mutation<
      ICreateLeadResponse,
      { session: string; callback: ICreateCallbackPayload }
    >({
      query: ({ session, callback }) => ({
        url: '/callbacks',
        method: 'POST',
        headers: { 'Guest-Uuid': session },
        body: { callback },
      }),
    }),
  }),
});

export const { useCreateLeadMutation, useCreateCallbackMutation } = leadApi;
